import React, {useState} from 'react';
import SideMenubar from '../DynamicSideMenubar';
import {ICONS} from '../../Constants/Icons';
import TopSearcher from './TopSearcher';
import TopNotification from './TopNotification';
import AppNavigationHeader from '../../Component/AppNavigation';
import TradlyAssistantPanel from '../../Component/TradlyAssistantPanel';
import {MagnifyingGlassIcon} from '@heroicons/react/24/outline';

const Header = ({sideMenuConfigReady = true}) => {
  const [isShowSidebar, setIsShowSidebar] = useState(false);
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  return (
    <React.Fragment>
      <TopNotification />
      <div
        id="app-main-header"
        className="w-full px-3 py-2 sticky top-0 z-[999] flex items-center justify-between gap-5 relative"
        style={{backgroundColor: 'var(--sidebar-bg)', color: 'var(--sidebar-text)'}}>

        {/* Mobile left: hamburger + logo */}
        <div className="md:hidden flex items-center gap-2.5 flex-none">
          <button onClick={() => setIsShowSidebar(!isShowSidebar)}>
            <img
              className="w-7 dark-header-menu-icon"
              src={isShowSidebar ? ICONS.closeIcon : ICONS.menu_Icon}
              alt=""
            />
          </button>
          {/* Tradly logo mark */}
          <div className="flex items-center gap-1.5">
            <svg width="22" height="22" viewBox="0 0 620 620" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="310" cy="310" r="220" stroke="var(--sidebar-text)" strokeOpacity="0.3" strokeWidth="28"/>
              <circle cx="310" cy="310" r="170" stroke="var(--sidebar-text)" strokeOpacity="0.55" strokeWidth="28"/>
              <circle cx="310" cy="310" r="120" stroke="var(--sidebar-text)" strokeOpacity="0.9" strokeWidth="28"/>
            </svg>
            <span className="text-sm font-extrabold tracking-tight" style={{color: 'var(--sidebar-text)'}}>Tradly</span>
          </div>
        </div>

        {/* Mobile centre: search toggle */}
        <button
          className="md:hidden flex items-center justify-center w-8 h-8 rounded-lg"
          style={{color: 'var(--sidebar-text)', opacity: 0.7}}
          onClick={() => setShowMobileSearch(s => !s)}>
          <MagnifyingGlassIcon style={{width: 18, height: 18}} strokeWidth={1.8} />
        </button>

        <div className="hidden md:block flex-1" />

        {/* Desktop: utility items in top bar */}
        <div className="hidden md:flex items-center">
          <AppNavigationHeader />
        </div>
        {/* Mobile only: app icons + YouTube + switcher */}
        <div className="flex-none md:hidden">
          <div className="flex items-center gap-2">
            <AppNavigationHeader mobileFull={true} />
          </div>
        </div>

        <TradlyAssistantPanel />

        {showMobileSearch && (
          <div className="md:hidden absolute top-full left-0 right-0 px-3 py-2 z-[998]"
            style={{backgroundColor: 'var(--sidebar-bg)', borderBottom: '1px solid var(--color-border)'}}>
            <TopSearcher sidebar={true} sidebarTextColor="var(--sidebar-text)" />
          </div>
        )}

        {isShowSidebar && (
          <div className=" fixed top-[48px] left-0 md:hidden  ">
            <SideMenubar
              isExpandSet={false}
              isConfigReady={sideMenuConfigReady}
              extra_styles={'!h-[calc(100dVH-60px)]'}
            />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default Header;
